import { createFileRoute } from '@tanstack/react-router';
import { ACCESS_ROUTES, getAccessiblePortfolios, useAccessContext } from '@vizit/access';
import { EntityGrid } from '@vizit/organisms';
import { guardPortfolioGrid } from '../../../router/route-utils';
import { HierarchyGridPage } from '../../../templates';

export const Route = createFileRoute('/_authenticated/portfolios/')({
  staticData: {
    pageName: 'Portfolios',
  },
  beforeLoad: async ({ context }) => {
    await guardPortfolioGrid(context);
  },
  component: PortfoliosRoute,
});

function PortfoliosRoute() {
  const { me, isLoading } = useAccessContext();
  const portfolios = me ? getAccessiblePortfolios(me) : [];

  const items = portfolios.map((portfolio) => ({
    id: portfolio.id,
    name: portfolio.name,
    href: ACCESS_ROUTES.portfolioWorkspaces(portfolio.id),
    meta: `${portfolio.workspaces.length} ${portfolio.workspaces.length === 1 ? 'workspace' : 'workspaces'}`,
  }));

  return (
    <HierarchyGridPage title={me?.organization.name ?? 'Portfolios'} className="gap-8">
      <EntityGrid items={items} isLoading={isLoading} emptyState={<p>No portfolios available.</p>} />
    </HierarchyGridPage>
  );
}
